(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-homepage"] && !Shopify.designMode) return;
  try {
    
  // JS fallback: measure the actual rendered topbar height and push the
  // shopify-account panel down, covering cases where the dialog is in a
  // shadow root or the CSS calc doesn't match the rendered height exactly.
  const initOkAccountPanelOffset = () => {
    const topbar = document.querySelector('.ok-editorial-home__topbar')
    if (!topbar) return

    const applyOffset = () => {
      const offset = topbar.getBoundingClientRect().height
      const panel =
        document.querySelector('shopify-account dialog') ||
        document.querySelector('shopify-account [role="dialog"]')
      if (!panel) return
      const currentTop = parseFloat(window.getComputedStyle(panel).top)
      if (isNaN(currentTop) || currentTop < offset) {
        panel.style.top = offset + 'px'
        panel.style.marginTop = '0'
      }
    }

    const account = document.querySelector('shopify-account')
    if (!account) return

    new MutationObserver(applyOffset).observe(account, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open'],
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOkAccountPanelOffset)
  } else {
    initOkAccountPanelOffset()
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-utilities"]) return;
  try {
    
  (function () {
    var wordmark = document.querySelector('[data-wordmark]');
    if (!wordmark) return;

    function triggerShimmer() {
      wordmark.removeAttribute('data-shimmer');
      void wordmark.offsetWidth;
      wordmark.setAttribute('data-shimmer', '');
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            wordmark.dataset.revealed = '';
            setTimeout(triggerShimmer, 700);
            observer.unobserve(wordmark);
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(wordmark);

    wordmark.addEventListener('mouseenter', function () {
      if (wordmark.hasAttribute('data-revealed')) {
        triggerShimmer();
      }
    });

    wordmark.addEventListener('click', function () {
      if (wordmark.hasAttribute('data-revealed')) {
        triggerShimmer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.performed) {
        this.initSlider();
        return;
      }

      if (!this.dataset.url) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.observer.disconnect();
            this.loadRecommendations();
          });
        },
        { rootMargin: '0px 0px 400px 0px' },
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.sliderController) {
        this.sliderController.abort();
        this.sliderController = null;
      }
    }

    async loadRecommendations() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) throw new Error(response.statusText);

        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const fetched = html.querySelector('product-recommendations');

        if (fetched && fetched.querySelector('[data-ok-recs-track]')) {
          this.innerHTML = fetched.innerHTML;
          this.dataset.performed = 'true';
          this.initSlider();
        } else {
          this.hidden = true;
        }
      } catch (error) {
        this.hidden = true;
      }
    }

    initSlider() {
      const track = this.querySelector('[data-ok-recs-track]');
      const nav = this.querySelector('[data-ok-recs-nav]');
      if (!track || !nav || this.sliderController) return;

      this.sliderController = new AbortController();
      const { signal } = this.sliderController;

      const prev = this.querySelector('[data-ok-recs-prev]');
      const next = this.querySelector('[data-ok-recs-next]');
      const thumb = this.querySelector('[data-ok-recs-thumb]');

      const isScrollable = () => track.scrollWidth - track.clientWidth > 1;

      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        if (max <= 1) {
          nav.hidden = true;
          return;
        }
        nav.hidden = false;

        const ratio = track.clientWidth / track.scrollWidth;
        const progress = track.scrollLeft / max;
        if (thumb) {
          thumb.style.width = Math.max(ratio * 100, 8) + '%';
          thumb.style.left = progress * (100 - Math.max(ratio * 100, 8)) + '%';
        }
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= max - 1;
      };

      const page = (direction) => {
        const slide = track.querySelector('.ok-recs__slide');
        const step = slide ? slide.getBoundingClientRect().width : track.clientWidth * 0.8;
        const amount = Math.max(step * Math.floor(track.clientWidth / step), step);
        track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      };

      if (prev) prev.addEventListener('click', () => page(-1), { signal });
      if (next) next.addEventListener('click', () => page(1), { signal });
      track.addEventListener('scroll', update, { passive: true, signal });
      window.addEventListener('resize', update, { passive: true, signal });

      if (!isScrollable()) nav.hidden = true;
      update();
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const setOkPdpBtnText = (btn, text) => {
    const label = btn.querySelector('span') || btn;
    label.textContent = text;
  };

  const setOkPdpAvailability = (availability, state) => {
    if (!availability) return;

    if (!state) {
      availability.hidden = true;
      return;
    }

    availability.hidden = false;
    const dot = availability.querySelector('[data-ok-pdp-availability-dot]');
    const text = availability.querySelector('[data-ok-pdp-availability-text]');
    if (dot) dot.className = `ok-pdp__status ok-pdp__status--${state}`;
    if (text) {
      text.textContent = state === 'sold-out' ? availability.dataset.soldOutText : availability.dataset.lowStockText;
    }
  };

  const getOkPdpVariants = (section) => {
    const variantsScript = section.querySelector('[data-ok-pdp-variants]');
    if (!variantsScript) return [];

    try {
      return JSON.parse(variantsScript.textContent || '[]');
    } catch (_error) {
      return [];
    }
  };

  const getOkPdpSelectedInputs = (section) =>
    Array.from(section.querySelectorAll('.ok-pdp__option-input:checked')).sort(
      (a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex),
    );

  const syncOkPdpOptionAvailability = (section, variants) => {
    const selectedOptions = getOkPdpSelectedInputs(section).map((selectedInput) => selectedInput.value);

    section.querySelectorAll('.ok-pdp__option-input').forEach((optionInput) => {
      const candidateOptions = [...selectedOptions];
      candidateOptions[Number(optionInput.dataset.optionIndex)] = optionInput.value;

      const matchOptions = (variant) => variant.options.every((option, index) => option === candidateOptions[index]);
      const variantExists = variants.some(matchOptions);
      const variantAvailable = variantExists && variants.some((variant) => variant.available && matchOptions(variant));

      optionInput.disabled = !variantExists;
      if (variantExists && !variantAvailable) {
        optionInput.setAttribute('data-sold-out', '');
      } else {
        optionInput.removeAttribute('data-sold-out');
      }
    });
  };

  const syncOkPdpGalleryMedia = (section, variantId) => {
    const gallery = section.querySelector('[data-ok-pdp-gallery]');
    if (!gallery) return;
    gallery.dispatchEvent(
      new CustomEvent('ok:pdp-variant-changed', {
        detail: { variantId: String(variantId) },
      }),
    );
  };

  const scrollToOkPdpMedia = (section, mediaId, variantId) => {
    if (!mediaId) return;
    const figure = section.querySelector(`[data-media-id="${mediaId}"]`);
    if (!figure) return;
    const ids = figure.dataset.variantIds;
    if (ids && !ids.split(',').includes(String(variantId))) return;
    figure.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  const syncOkPdpVariant = (section) => {
    const variants = getOkPdpVariants(section);
    const variantIdInput = section.querySelector('[data-ok-pdp-variant-id]');
    const price = section.querySelector('[data-ok-pdp-price]');
    const availability = section.querySelector('[data-ok-pdp-availability]');
    const addButton = section.querySelector('[data-ok-pdp-add]');
    const selectedInputs = getOkPdpSelectedInputs(section);

    selectedInputs.forEach((selectedInput) => {
      const label = section.querySelector(
        `[data-ok-pdp-option-value="${Number(selectedInput.dataset.optionIndex) + 1}"]`,
      );
      if (label) label.textContent = selectedInput.value;
    });

    const selectedOptions = selectedInputs.map((selectedInput) => selectedInput.value);
    const variant = variants.find((candidate) =>
      candidate.options.every((option, index) => option === selectedOptions[index]),
    );

    syncOkPdpOptionAvailability(section, variants);

    if (!variant) {
      if (variantIdInput) variantIdInput.value = '';

      setOkPdpAvailability(availability, 'sold-out');

      if (addButton) {
        addButton.disabled = true;
        setOkPdpBtnText(addButton, addButton.dataset.soldOutText);
      }

      return;
    }

    const available = variant.available === true;

    if (variantIdInput) variantIdInput.value = variant.id;
    if (price) price.textContent = variant.price;

    setOkPdpAvailability(availability, available ? (variant.low_stock ? 'low-stock' : null) : 'sold-out');

    if (addButton) {
      addButton.disabled = !available;
      setOkPdpBtnText(addButton, available ? addButton.dataset.addText : addButton.dataset.soldOutText);
    }

    syncOkPdpGalleryMedia(section, variant.id);
    scrollToOkPdpMedia(section, variant.featured_media_id, variant.id);

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.ok-pdp__option-input');
    if (!input) return;

    const section = input.closest('.ok-pdp');
    if (section) syncOkPdpVariant(section);
  });

  const initOkPdpVariants = () => {
    document.querySelectorAll('.ok-pdp').forEach((section) => {
      if (section.querySelector('[data-ok-pdp-variants]')) syncOkPdpVariant(section);
    });
  };

  const initOkPdpScrollBar = () => {
    const gallery = document.querySelector('[data-ok-pdp-gallery]');
    if (!gallery) return;
    const thumb = gallery.parentElement.querySelector('.ok-pdp__scroll-thumb');
    if (!thumb) return;

    const update = () => {
      const { scrollLeft, scrollWidth, clientWidth } = gallery;
      if (scrollWidth <= clientWidth) return;
      thumb.style.width = (clientWidth / scrollWidth) * 100 + '%';
      thumb.style.left = (scrollLeft / scrollWidth) * 100 + '%';
    };

    gallery.addEventListener('scroll', update, { passive: true });
    update();
  };

  const initOkPdpZoom = () => {
    const section = document.querySelector('.ok-pdp');
    if (!section) return;

    const cursorWrap = document.createElement('div');
    cursorWrap.className = 'ok-pdp__cursor-wrap';
    cursorWrap.setAttribute('aria-hidden', 'true');
    const cursorEl = document.createElement('div');
    cursorEl.className = 'ok-pdp__cursor';
    cursorEl.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <line x1="2" y1="10" x2="18" y2="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <line class="ok-pdp__cursor-v" x1="10" y1="2" x2="10" y2="18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`;
    cursorWrap.appendChild(cursorEl);
    document.body.appendChild(cursorWrap);

    let zoomedFig = null;

    const getImg = (fig) => fig.querySelector('.ok-pdp__image');

    const pan = (fig, e) => {
      const img = getImg(fig);
      if (!img) return;
      const rect = fig.getBoundingClientRect();
      const x = (((e.clientX - rect.left) / rect.width) * 100).toFixed(2);
      const y = (((e.clientY - rect.top) / rect.height) * 100).toFixed(2);
      img.style.transformOrigin = `${x}% ${y}%`;
    };

    const unzoom = (fig) => {
      fig.classList.remove('ok-pdp__media-item--zoomed');
      cursorEl.classList.remove('ok-pdp__cursor--zoomed');
      const img = getImg(fig);
      if (img) {
        setTimeout(() => {
          if (!fig.classList.contains('ok-pdp__media-item--zoomed')) {
            img.style.transformOrigin = '';
          }
        }, 420);
      }
      if (zoomedFig === fig) zoomedFig = null;
    };

    const zoom = (fig, e) => {
      if (zoomedFig && zoomedFig !== fig) unzoom(zoomedFig);
      pan(fig, e);
      fig.classList.add('ok-pdp__media-item--zoomed');
      cursorEl.classList.add('ok-pdp__cursor--zoomed');
      zoomedFig = fig;
    };

    section.addEventListener('click', (e) => {
      const fig = e.target.closest('[data-zoom-src]');
      if (!fig) {
        if (zoomedFig) unzoom(zoomedFig);
        return;
      }
      if (fig === zoomedFig) {
        unzoom(fig);
      } else {
        zoom(fig, e);
      }
    });

    section.addEventListener('mousemove', (e) => {
      const fig = e.target.closest('[data-zoom-src]');
      cursorWrap.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
      if (fig || zoomedFig) {
        cursorEl.classList.add('ok-pdp__cursor--visible');
      } else {
        cursorEl.classList.remove('ok-pdp__cursor--visible');
      }
      if (zoomedFig) pan(zoomedFig, e);
    });

    section.addEventListener('mouseleave', () => {
      if (!zoomedFig) cursorEl.classList.remove('ok-pdp__cursor--visible');
    });

    section.addEventListener('dragstart', (e) => {
      if (e.target.tagName === 'IMG') e.preventDefault();
    });
  };

  const initOkPdp = () => {
    initOkPdpVariants();
    initOkPdpScrollBar();
    initOkPdpZoom();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOkPdp);
  } else {
    initOkPdp();
  }

  } catch(e) { console.error(e); }
})();
})();
